import React, { useEffect, useState } from 'react';
import './App.css';
import Header from './components/Header/Header.jsx';
import Hero from './components/Hero/Hero.jsx';
import About from './components/About/About.jsx';
import Services from './components/Services/Services.jsx';
import Products from './components/Products/Products.jsx';
import Customers from './components/Customers/Customers.jsx';
import Contact from './components/Contact/Contact.jsx';
import Footer from './components/Footer/Footer.jsx';
import ParticlesBackground from './components/Particles/Particles.jsx';
import userDeviceInfo from './utils/tracking/userDeviceInfo';
import { saveUserDeviceInfo, updateUserDeviceSession, isFirebaseConfigured } from './middleware/firebaseMiddleware';
import { getCurrentSession, createSession, clearSession } from './utils/tracking/sessionManager';

function App() {
  const [deviceDocId, setDeviceDocId] = useState(null);

  useEffect(() => {
    const initDeviceTracking = async () => {
      try {
        const existingSession = getCurrentSession();

        if (existingSession) {
          setDeviceDocId(existingSession.deviceDocId);
          return;
        }

        await userDeviceInfo.collect();
        userDeviceInfo.logDeviceInfo();

        if (isFirebaseConfigured()) {
          const data = userDeviceInfo.getFirebaseData();
          const docId = await saveUserDeviceInfo(data);

          if (docId) {
            setDeviceDocId(docId);
            createSession(docId);
          }
        } else {
          console.warn('⚠️ Firebase not configured. Device info will not be saved.');
        }
      } catch (error) {
        console.error('Error initializing device tracking:', error);
      }
    };

    initDeviceTracking();

    const handleBeforeUnload = () => {
      userDeviceInfo.logSessionEnd();

      if (isFirebaseConfigured() && deviceDocId) {
        const data = userDeviceInfo.getFirebaseData();
        updateUserDeviceSession(deviceDocId, data).catch(err => {
          console.error('Error updating session end:', err);
        });
      }

      clearSession();
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      userDeviceInfo.logSessionEnd();

      if (isFirebaseConfigured() && deviceDocId) {
        const data = userDeviceInfo.getFirebaseData();
        updateUserDeviceSession(deviceDocId, data).catch(err => {
          console.error('Error updating session end:', err);
        });
      }
    };
  }, []);

  return (
    <div className="App">
      <ParticlesBackground />
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Products />
        <Customers />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
